export default "__VITE_PUBLIC_ASSET__78463e61__"